import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getProductById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `/produto/produtoById?id=${id}`;
	const response = await api.get(url);
	return response.data;
};
export const useGetProductWithId = (id: number) => {
	return useQuery(['productWithId', id], getProductById, {
		refetchOnWindowFocus: false,
	});
};
